// extracted by mini-css-extract-plugin
export default {"main_div":"DiscussAndLearnArea_main_div__pCc34","calendar_height":"DiscussAndLearnArea_calendar_height__NERR0"};